export default __webpack_public_path__ + "static/logo-9ddbf3432d992a45b96da347f8741005.svg";